// FirebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyAFkpmANYeeNk92f1LM0ATK9xYfG8twIMs",
  authDomain: "aditya2026-28e19.firebaseapp.com",
  projectId: "aditya2026-28e19",
  storageBucket: "aditya2026-28e19.firebasestorage.app",
  messagingSenderId: "838564592462",
  appId: "1:838564592462:web:c3167f7f23adad50a97c1f",
  measurementId: "G-NR8PD40G31"
};


const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);  // Create and export the auth object

export { firestore, auth };
